import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { SearchRounded } from '@mui/icons-material';

type ActionResponse = { id: string }[];

export type AndieGetPostsByFilterToolProps = ActionRenderAi<ActionResponse>;

const AndieGetPostsByFilterTool = (props: AndieGetPostsByFilterToolProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse>
            title={() => t('andie.tool.get-posts-by-filter.title')}
            icon={<SearchRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.get-posts-by-filter.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.get-posts-by-filter.complete', {
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieGetPostsByFilterTool;
